import { format, parse } from 'date-fns'

export default function useUtils() {
  const formatProductPreorderDate = (date?: string | null) => {
    if (!date) { return '' }
    return format(parse(date, 'yyyy-MM-dd', new Date()), 'MM.yyyy')
  }

  return { formatProductPreorderDate }
}
